<app-header>
  <div title>
    {{ 'connectionpoint.create.title' | translate }}
  </div>
</app-header>
<div class="p-6">
  <form [formGroup]="form">
    <!-- ConnectionPoint Specific -->
    <app-guide-card [valid]="form.get('connectionPointCategoryId')?.valid">
      <div title>{{ 'connectionPoint.create.coredata.title' | translate }}</div>
      <div description>{{ 'connectionPoint.create.coredata.description' | translate }}</div>
      <div>
        <app-input-group>
          <label appLabel>{{ 'connectionPoint.create.form.category' | translate }}</label>
          <select appSelect formControlName="connectionPointCategoryId" [collection]="connectionPointCategoryList"></select>
        </app-input-group>

        <div class="bg-slate-100 dark:bg-dark-border w-full h-[1px] mt-6 mb-4"></div>

        <app-input-group>
          <label appLabel>{{ 'connectionPoint.create.form.description' | translate }}</label>
          <textarea appInput formControlName="description" [placeholder]="('common.define' | translate) + ' ' + ('connectionPoint.create.form.description' | translate)"></textarea>
        </app-input-group>

      </div>
    </app-guide-card>

    <app-guide-card>
      <div title>{{ 'connectionRight.sectionTitle' | translate }}</div>
      <app-input-group>
        <label appLabel>{{ 'connectionRight.owner' | translate }}</label>
        <select appSelect formControlName="connectionPointOwnsConnectionRights" (change)="selectConnectionRightOwner($event)">
          <option value="true">{{ 'connectionRight.ownerConnectionPoint' | translate }}</option>
          <option value="false">{{ 'connectionRight.ownerMeterFrame' | translate }}</option>
        </select>
      </app-input-group>

      <div formGroupName="initialConnectionRight">
        @if (connectionPointOwnsConnectionRights) {
          <app-connection-right-form [form]="initialConnectionRightForm" [showTitle]="false"></app-connection-right-form>
        }
      </div>
    </app-guide-card>

    <!--- Address --->
    <app-meteringpoint-form-address formGroupName="address" [fullWidth]="false" [form]="form"></app-meteringpoint-form-address>

    <app-guide-card [valid]="form.get('identification')?.valid && form.get('stationNumber')?.valid">
      <div title>{{ 'connectionPoint.create.alternative.title' | translate }}</div>
      <div description>{{ 'connectionPoint.create.alternative.description' | translate }}</div>
      <div>
        <app-input-group>
          <label appLabel>{{ 'connectionPoint.create.form.identification' | translate }}</label>
          <input
            appInput
            formControlName="identification"
            placeholder="{{ 'connectionPoint.create.form.identification' | translate }}">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionPoint.create.form.alternativeIdentification' | translate }}</label>
          <input
            appInput
            formControlName="alternativeIdentification"
            placeholder="{{ 'connectionPoint.create.form.alternativeIdentification' | translate }}">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionPoint.create.form.stationsNumber' | translate }}</label>
          <input
            appInput
            formControlName="stationNumber"
            placeholder="{{ 'connectionPoint.create.form.stationsNumber' | translate }}">
        </app-input-group>

      </div>
    </app-guide-card>

    <!-- Key section -->
    <app-guide-card>
      <div title>{{ 'connectionpoint.key' | translate }}</div>
      <div formGroupName="accessKey">
        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.number' | translate }}</label>
          <input appInput formControlName="number">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.placementType' | translate }}</label>
          <input appInput formControlName="placementType">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.code' | translate }}</label>
          <input appInput formControlName="code">
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.remarks' | translate }}</label>
          <textarea appInput rows="3" formControlName="remarks"></textarea>
        </app-input-group>

        <app-input-group>
          <label appLabel>{{ 'connectionpoint.keyFields.facility' | translate }}</label>
          <input appInput formControlName="facility">
        </app-input-group>
      </div>
    </app-guide-card>

    <app-guide-card>
      <div title>{{ 'connectionpoint.sharedInstallation.title' | translate }}</div>
      <app-input-group>
        <label appLabel>{{ 'connectionpoint.sharedInstallation.hasSharedServiceLine' | translate }}</label>
        <input type="checkbox" appInput formControlName="hasSharedServiceLine">
      </app-input-group>
      <app-input-group>
        <label appLabel>{{ 'connectionpoint.sharedInstallation.hasCollectiveMetering' | translate }}</label>
        <input type="checkbox" appInput formControlName="hasCollectiveMetering">
      </app-input-group>
      <app-input-group>
        <label appLabel>{{ 'connectionpoint.sharedInstallation.numberOfInstallations' | translate }}</label>
        <input appInput type="number" min="1" step="1" formControlName="numberOfInstallations">
      </app-input-group>
      <app-input-group>
        <label appLabel>{{ 'connectionpoint.sharedInstallation.categoryOfInstallations' | translate }}</label>
        <select appSelect formControlName="categoryOfInstallationsId" [collection]="connectionPointCategoryList"></select>
      </app-input-group>
    </app-guide-card>

    <app-guide-card>
      <div title>{{ 'systemServices.title' | translate }}</div>
      <div>
        <app-input-group>
          <label appLabel>{{ 'systemServices.type' | translate }}</label>
          <select appSelect formControlName="systemServicesType" [collection]="systemServiceTypeOptions"></select>
        </app-input-group>
        <app-input-group>
          <label appLabel>{{ 'systemServices.capacity' | translate }}</label>
          <input appInputNumber formControlName="systemServicesCapacity" [decimals]="1" append="kW">
        </app-input-group>
      </div>
    </app-guide-card>
  </form>

  <div class="flex gap-4">
    <div class="w-1/5"></div>
    <div class="w-2/5">
      <app-card>
        <div class="flex justify-between">
          <div>
            <button
              appButton
              type="tertiary"
              (click)="cancel()">{{ 'common.cancel' | translate }}</button>
          </div>
          <div>
            <button
              appButton
              (click)="create()"
            >{{ 'common.create' | translate }}</button>
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>
